import React, { forwardRef } from 'react';
import { BOForm } from './Form';
/**
 * The Bulk Order Vehicle Details Form serves as a simple way by which Bulk
 * Order-relevant Asset information can be viewed, added, or edited.
 *
 * The `BOVehicleDetailsForm` requires the `BOVehicleDetailsFormContext`.
 * Therefore, it should always be wrapped by a `BOVehicleDetailsFormProvider`.
 */
var BOVehicleDetailsForm = forwardRef(function (props, ref) {
    var onSubmit = props.onSubmit, onValidationFailed = props.onValidationFailed, defaultValues = props.defaultValues, readOnly = props.readOnly, mode = props.mode, onDirtyStateChanged = props.onDirtyStateChanged, optionalOption = props.optionalOption;
    return (React.createElement(BOForm, { formDefinition: {}, onSubmit: onSubmit, onValidationFailed: onValidationFailed, onDirtyStateChanged: onDirtyStateChanged, defaultValues: defaultValues, readOnly: readOnly, mode: mode, ref: ref, optionalOption: optionalOption }));
});
export { BOVehicleDetailsForm };
//# sourceMappingURL=BOVehicleDetailsForm.js.map